module.exports = __webpack_public_path__ + "static/media/executive.33591127.png";